import { formatDate, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import {
  APPROVAL_REQUEST_CONFIG,
  DISPLAY_STATUS,
  STATUS_CANCELLED,
  STATUS_STYLE_MAP,
} from '../../../constants/ApprovalRequestConstants'
import { Error, Loader, SSDMaterialsList } from '../../common'
import { fetchOffCycleTestingApprovalRequestHistory } from '../../../actions/approvalRequestHistory'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestType,
} from '../../../selectors/approvalRequests'
import { getOffCycleTestingRequestHistory } from '../../../selectors/requestHistory'
import { SSD_MATERIALS_STYLE_MAP } from '../../../constants/NonStockedSSDConstants'
import { selectExamWindowRefData } from '../../../selectors/examWindows'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const arType = selectApprovalRequestType(state)
  const { fetching, error } = getOffCycleTestingRequestHistory(state)
  const arId = selectedApprovalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
  return {
    approvalHistory: getOffCycleTestingRequestHistory(state, arId),
    examWindows: selectExamWindowRefData(state),
    arId,
    fetching,
    error,
    panelIsOpen,
  }
}

const StatusExamDate = ({ etsApprovalStatus, examDate, examWindows }) => {
  if (examDate) {
    return (
      <div style={{ fontStyle: 'normal' }}>
        Exam Date {formatDate(examDate, DATETIME_FORMATS.shortMonthDay)}
      </div>
    )
  }
  return (
    <div style={{ fontStyle: 'normal' }}>
      {examWindows[etsApprovalStatus.examDateType].displayName}
    </div>
  )
}

const StatusComments = ({ comments }) => {
  if (comments) {
    return <div style={{ fontStyle: 'italic' }}>{`"${comments}"`}</div>
  }
  return null
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchOffCycleTestingApprovalRequestHistory }, dispatch)

const ApprovalRequestHistoryRow = connect(mapStateToProps)(
  ({ status, key, first, examWindows }) => {
    const { etsApprovalStatus, reviewedBy, ssdDataSet, comments, updateTimestamp, isPaper } = status
    return (
      <tr key={key}>
        <td style={first ? { borderTopWidth: 0 } : {}}>
          <div style={STATUS_STYLE_MAP[etsApprovalStatus]}>{DISPLAY_STATUS[etsApprovalStatus]}</div>
          {ssdDataSet.length && etsApprovalStatus !== STATUS_CANCELLED ? (
            <SSDMaterialsList selectedSSDMaterials={ssdDataSet} isPaper={isPaper}>
              <div style={SSD_MATERIALS_STYLE_MAP[etsApprovalStatus]} />
            </SSDMaterialsList>
          ) : null}
          <StatusExamDate etsApprovalStatus={status} examWindows={examWindows} />
          {reviewedBy && <div>Processed By: {reviewedBy}</div>}
          {comments && <StatusComments comments={comments} />}
        </td>
        <td style={first ? { borderTopWidth: 0, whiteSpace: 'nowrap' } : { whiteSpace: 'nowrap' }}>
          {formatDate(updateTimestamp, DATETIME_FORMATS.longMonthDayYear)}
        </td>
      </tr>
    )
  }
)

const ApprovalRequestHistoryTable = connect(mapStateToProps)(({ approvalHistory = [] }) => {
  return (
    <table
      className="table"
      summary="Status of Off-Cycle Testing approval requests are listed by status date in descending order."
    >
      <caption className="sr-only">A view of Off-Cycle Testing approval request history</caption>
      <thead>
        <tr>
          <th scope="col">Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {approvalHistory.map((row, index) => (
          <ApprovalRequestHistoryRow status={row} key={`${Math.random()}`} first={index === 0} />
        ))}
      </tbody>
    </table>
  )
})

class RequestHistory extends Component {
  componentDidMount() {
    const { arId, fetchOffCycleTestingApprovalRequestHistory } = this.props

    fetchOffCycleTestingApprovalRequestHistory(arId)
  }

  componentDidUpdate(prevProps) {
    const { arId, panelIsOpen, fetchOffCycleTestingApprovalRequestHistory } = this.props

    if (panelIsOpen && prevProps.arId !== arId) {
      fetchOffCycleTestingApprovalRequestHistory(arId)
    }
  }

  render() {
    const { approvalHistory = [], fetching, error } = this.props
    let output = null

    if (fetching) {
      output = <Loader />
    } else if (error) {
      output = <Error title="Error" message={error} />
    } else if (approvalHistory.length) {
      output = <ApprovalRequestHistoryTable />
    } else {
      output = <>No request history available</>
    }

    return (
      <div className="row" style={{ paddingBottom: '1.5em' }}>
        <div className="col-xs-12">{output}</div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestHistory)
